import React, { FC } from 'react';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { CZEN_GENERAL },
} = getConfig();

const CareLogo: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 40"
      height={40}
      width={100}
      data-testid="careAltLogo">
      <image width={100} height={40} href={`${CZEN_GENERAL}/s/d/ttp/cfb-logo-mfe.svg`} />
    </svg>
  );
};

export default CareLogo;
